import React from "react";
import { ChevronRight } from "lucide-react";

/**
 * Hero-Block für App-Übersichten (MatchMixer / ClubChamp / Regeltermine).
 * @param {{
 *   ariaLabel: string,
 *   brand: string,
 *   tagline?: string,
 *   title: string,
 *   subtitle?: string,
 *   media?: { src: string, srcWide?: string, width?: number, height?: number, sizes?: string, srcSet?: string },
 *   primaryAction?: React.ReactNode,
 *   secondaryAction?: React.ReactNode,
 * }} props
 */
export function AppHubHero({
  ariaLabel,
  brand,
  tagline,
  title,
  subtitle,
  media,
  primaryAction,
  secondaryAction,
}) {
  const srcSet =
    media?.srcSet ||
    (media?.srcWide ? `${media.src} 640w, ${media.srcWide} 960w` : undefined);

  return (
    <section className="mm-hub__hero" aria-label={ariaLabel}>
      {media?.src ? (
        <div className="mm-hub__heroMedia" aria-hidden="true">
          <img
            className="mm-hub__heroImg"
            src={media.src}
            srcSet={srcSet}
            sizes={media.sizes || "(max-width: 900px) 100vw, 1100px"}
            alt=""
            width={media.width || 1440}
            height={media.height || 480}
            decoding="async"
            fetchpriority="high"
          />
          <div className="mm-hub__heroScrim" />
        </div>
      ) : null}
      <div className="mm-hub__heroContent">
        <p className="mm-hub__heroBrand">{brand}</p>
        {tagline ? <p className="mm-hub__heroTagline">{tagline}</p> : null}
        <h1 className="mm-hub__heroTitle">{title}</h1>
        {subtitle ? <p className="mm-hub__heroSubtitle">{subtitle}</p> : null}
        {primaryAction || secondaryAction ? (
          <div className="mm-hub__heroCtaGroup">
            {primaryAction}
            {secondaryAction}
          </div>
        ) : null}
      </div>
    </section>
  );
}

/** Hilfs-CTA mit Chevron — Link oder Button als children-Wrapper. */
export function AppHubHeroCta({
  as: Comp = "button",
  secondary = false,
  children,
  ...rest
}) {
  const className = [
    "btn",
    secondary ? "btn--ghost" : "btn--primary",
    "mm-hub__heroCta",
    secondary ? "mm-hub__heroCta--secondary" : "",
    rest.className || "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <Comp {...rest} className={className}>
      <span>{children}</span>
      <ChevronRight size={18} strokeWidth={2.5} aria-hidden="true" />
    </Comp>
  );
}
